import React from 'react';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-5 md:py-6 px-4 border-y border-brand-accent/30" data-id="element-239">
      <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-240">
        <div className="flex flex-col items-center text-center" data-id="element-241">
          <Users className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-242" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-243">+300</span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-244">
            docentes confían
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-245">
          <BookCopy className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-246" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-247">
            6 Tomos
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-248">
            listos para usar
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-249">
          <Gift className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-250" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-251">
            4 Bonos
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-252">
            incluidos gratis
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-253">
          <div className="flex mb-1.5" data-id="element-254">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 text-brand-accent fill-current" data-id="element-255" />)}
          </div>
          <span className="text-lg md:text-xl font-black text-white" data-id="element-256">
            4.9/5
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-257">
            valoración
          </span>
        </div>
      </div>
    </div>;
}